import { render, staticRenderFns } from "./Cotacoes.vue?vue&type=template&id=75053857"
import script from "./Cotacoes.vue?vue&type=script&lang=js"
export * from "./Cotacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports